<template>
    <div>
        <div style="display: flex; flex: 1; justify-content: flex-end;">
            <v-checkbox
                v-model="showDateWithEmptyData"
                color="secondary lighten-1"
                label="Mostrar datas com dados ausentes"
            ></v-checkbox>
        </div>

        <div class="mb-12" v-for="(observedTable, indexTable) in observedTables" :key="`hourlytable${indexTable}`">
            <div class="mb-3">
                <v-icon class="mr-2" color="secondary lighten-1" size="20">{{mapIconBySensorId(observedTable.sensor.codigo)}}</v-icon>
                <strong style="font-size: 16px;line-height: 20px;">{{observedTable.sensor.name}}</strong>
            </div>
            <observed-table-data-by-sensor
                :headers="observedTable.headers"
                :hourColumnKeys="observedTable.hourColumnKeys"
                :items="observedTable.items"
                :qualitiesTags="qualitiesTags"
                :showDateWithEmptyData="showDateWithEmptyData"
            >
            </observed-table-data-by-sensor>
        </div>

        <observed-table-data-to-export
            ref="observedTableDataToExport"
            :searchResult="searchResult"
            :dataPeriodDate="dataPeriodDate"
            :qualitiesTags="qualitiesTags"
            :exportFileName="exportFileName"
        >
        </observed-table-data-to-export>

        <h1 style="font-style: normal;font-weight: 500;font-size: 16px;line-height: 20px;">Controle de qualidade</h1>
        <div class="mt-4 mb-6" style="display: flex;">
            <div class="mr-3" v-for="(qualityValue, index) in qualitiesTags" :key="index">
                <v-chip 
                    class="mr-2 px-3 py-1"
                    :color="qualityValue.background"
                    :style="`border: 1px solid ${qualityValue.borderColor}`"
                    label
                >
                    <span :style="`color: ${qualityValue.textColor}`">{{qualityValue.title}}</span>
                </v-chip>
                <span>{{qualityValue.description}}</span>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import ObservedTableDataBySensor from "./ObservedTableDataBySensor.vue";
/* import { jsPDF } from "jspdf" */
import writeXlsxFile from 'write-excel-file'
import ObservedTableDataToExport from './TableToExportPDF/ObservedTableDataToExport.vue';
export default {
    name: "ObservedTableData",
    props: {
        searchResult:{
            type: Object
        },
        dataPeriodDate:{
            type: Array
        }
    },
    components:{
        ObservedTableDataBySensor,
        ObservedTableDataToExport,
    },
    data:()=>({
        showDateWithEmptyData: true,
        headers: [],
        items:[],
        hourColumnKeys: [],
        observedTables: [],
        minutes:["00", "15", "30", "45"],
        qualitiesTags:[
            {
                qualitiyId: 0,
                title: "A",
                description: "Aprovado",
                background: "rgba(82, 179, 71, 0.1)",
                textColor: "#52B347",
                borderColor: "rgba(82, 179, 71, 0.3)"
            },
            {
                qualitiyId: 1,
                title: "S",
                description: "Suspeito",
                background: "rgba(255, 121, 0, 0.1)",
                textColor: "#FF7C55",
                borderColor: "rgba(255, 121, 0, 0.3)"
            },
            {
                qualitiyId: 4,
                title: "NV",
                description: "Não verificado",
                background: "rgba(160, 160, 160, 0.1)",
                textColor: "#A0A0A0",
                borderColor: "rgba(160, 160, 160, 0.3)"
            },
            {
                qualitiyId: 2,
                title: "PF",
                description: "Possível falha",
                background: "rgba(242, 204, 12, 0.2)",
                textColor: "#FFAE27",
                borderColor: "rgba(242, 204, 12, 0.3)"
            },
            {
                qualitiyId: 3,
                title: "R",
                description: "Reprovado",
                background: "rgba(255, 49, 69, 0.1)",
                textColor: "#FC424A",
                borderColor: "rgba(255, 49, 69, 0.3)"
            }
        ]
    }),

    created(){
        this.initialize();
    },

    watch:{

        searchResult(value){
            if(value){
                this.initialize();
            }
        }
    },

    methods:{
        initialize(){
            const { sensors, resultList } = this.searchResult;
            this.observedTables = [];
            for (const sensor of sensors) {
                const hourColumnKeys = this.generateColumsKeys(resultList, sensor.codigo);
                const headers = this.generateHeaders(hourColumnKeys);
                const generatedItems = this.generateObservedItems(resultList, sensor.codigo);
                const groupItems = this.groupItemsByDate(generatedItems);
                const items = this.sortGroupItemsByMinute(groupItems, this.minutes);
                this.observedTables.push({ hourColumnKeys, headers, items, sensor });
                this.exportFileName = this.generateExportFileName(this.searchResult);
            }
        },

        generateColumsKeys(resultList, sensorId){
            const resultsBySensorId = resultList.filter((result) => result.sensorId === sensorId);
            const keys = [];
            for (const result of resultsBySensorId) {
                const { datahora } = result;
                const hourKey = moment(datahora).tz("America/Sao_Paulo").format("HH");
                if(keys.indexOf(hourKey) === -1) keys.push(hourKey);
            }
            const sortedKeys = this.sortColumnsKeys(keys);
            return sortedKeys.map(key => key.toString().padStart(2, "0"))
        },

        sortColumnsKeys(keys){
            const keysNumbers = keys.map(key => Number(key));
            return keysNumbers.sort((a, b) => a - b);
        },

        generateHeaders(hourColumnKeys){
            const headers = []
            const dateHeader = {
                text: "",
                align: 'start',
                sortable: false,
                value: 'date',
                width: 80,
            };
            const minuteHeader = {
                text: "",
                align: 'start',
                sortable: false,
                value: 'minute',
                width: 80,
            };
            headers.push(dateHeader);
            headers.push(minuteHeader);
            for (const hourKey of hourColumnKeys) {
                headers.push({
                    text: hourKey,
                    align: 'center',
                    sortable: true,
                    value: `hour${hourKey}Value`,
                    width: 100,
                });
            }
            return headers;
        },

        generateObservedItems(resultList, sensorId){
            const resultsBySensorId = resultList.filter((result) => result.sensorId === sensorId);
            const items = [];
            for (const result of resultsBySensorId) {
                const { datahora } = result;

                items.push({
                    date: moment(datahora).tz("America/Sao_Paulo").format("DD/MM/YYYY"),
                    minute:moment(datahora).tz("America/Sao_Paulo").format("mm"),
                    dateIso: datahora,
                    value: result.leitura,
                    sensorId: result.sensorId,
                    qualidadeId: result.leitura || result.leitura === 0 ? result.qualidadeId : undefined,
                })
            }
            return items;
        },

        groupItemsByDate(items){
            const groupItems = [];
            const dateKeys = [];
            for (const item of items) {
                const { date, minute } = item;
                if(!dateKeys.find((dateKey) => dateKey.date === date && dateKey.minute === minute)) dateKeys.push({date, minute});
            }
            for (const dateKey of dateKeys) {
                const { date, minute } = dateKey;
                let groupItem = { date, minute };
                const resultsByDate = items.filter((item) => item.date === date && item.minute === minute);
                for (const result of resultsByDate) {
                    const { value, sensorId, dateIso, qualidadeId } = result; 
                    const hourKey = moment(dateIso).tz("America/Sao_Paulo").format("HH");
                    groupItem.dateIso = moment(dateIso).tz("America/Sao_Paulo").format("YYYY-MM-DD");
                    groupItem[`hour${hourKey}Value`] = value;
                    groupItem[`hour${hourKey}Id`] = sensorId;
                    groupItem[`hour${hourKey}qualityId`] = qualidadeId;
                }
                groupItems.push(groupItem);
            }
            return groupItems;
        },

        sortGroupItemsByMinute(groupItems, minutesInterval){
            const datesGroup = [];
            for (const item of groupItems) {
                const { date } = item;
                if(!datesGroup.find((dateGroup) => dateGroup === date)){
                    datesGroup.push(date)
                }
            }
            const sortedGroups = [];
            for (const date of datesGroup) {
                let firstMinuteAdded = false;
                for (const minute of minutesInterval) {
                   const findGroupItem = groupItems.find(item => item.date === date && item.minute === minute);
                   if(findGroupItem){
                        sortedGroups.push({...findGroupItem, highlightDate: !firstMinuteAdded}); 
                        if(!firstMinuteAdded) firstMinuteAdded = true;
                   }
                    
                }
            }
            return sortedGroups;
        },

        mapIconBySensorId(code){
            if(code === 1 || code === 3 || code === 4 || code === 5){
                return 'icon-infohidro-termometro'
            } else if(code === 2){
                return 'mdi-water-alert-outline'
            } else if(code === 6){
                return 'mdi-sun-wireless'
            } else if(code === 7){
                return 'mdi-weather-pouring'
            } else if(code === 8 || code === 9 || code === 10){
                return 'mdi-weather-windy'
            } else if(code === 15){
                return 'mdi-gauge'
            } else if(code === 18){
                return 'mdi-arrow-expand-vertical'
            } else if(code === 33){
                return 'mdi-waves'
            } else {
                return 'icon-infohidro-volume'
            }
        },

        generatePDF(settings) {
            this.$refs.observedTableDataToExport.generatePDF(settings);
        },

        generateCSV(settings){
            let csvContent = "data:text/csv;charset=utf-8,";
            const mapItems = this.applySettings(settings,this.mapItemsToExport(this.searchResult.resultList));
            csvContent += [
                Object.keys(mapItems[0]).join(";"),
                ...mapItems.map(item => Object.values(item).join(";"))
            ]
                .join("\n")
                .replace(/(^\[)|(\]$)/gm, "");

            const data = encodeURI(csvContent);
            const link = document.createElement("a");
            link.setAttribute("href", data);
            link.setAttribute("download", `${this.exportFileName}.csv`);
            link.click();
        },

        async generateXLS(settings){
            const mapItems = this.applySettings(settings,this.mapItemsToExport(this.searchResult.resultList));
            const columns = Object.keys(mapItems[0]);
            const schema = columns.map((column) => ({ column, type: String, fontStyle: "normal", value: item => item[column] }));
            await writeXlsxFile(mapItems, {
                schema,
                fileName: `${this.exportFileName}.xlsx`,
                headerStyle: {
                    fontWeight: 'normal',
                    align: 'center'
                },
            });
        },

        mapItemsToExport(items){
            return this.groupItemsByDateToExport(items);
        },

        groupItemsByDateToExport(items){
            const groupItems = [];
            const dateKeys = [];
            for (const item of items) {
                const { datahora } = item;
                if(dateKeys.indexOf(datahora) === -1) dateKeys.push(datahora);
            }
            for (const dateKey of dateKeys) {
                let groupItem = { date: moment(dateKey).tz("America/Sao_Paulo").format("YYYY-MM-DDTHH:mm") };
                const resultsByDate = items.filter((item) => item.datahora === dateKey);
                for (const result of resultsByDate) {
                    const { leitura, sensorId } = result; 
                    const sensorFind = this.searchResult.sensors.find(sensor =>sensor.codigo == sensorId);
                    groupItem[sensorFind.name] = leitura || leitura === 0 ? leitura.toString() : "";
                }
                groupItems.push(groupItem);
            }
            return groupItems;
        },

        applySettings(settings, items){
            const {option, replaceData} = settings;
            if(option === "replace-data" && replaceData){
                return this.replaceEmptyValue(items, replaceData);
            }
            if(option === "remove-dates-with-empty-values"){
                return this.removeDatesWithEmptyValues(items);
            }
            return items;
        },

        replaceEmptyValue(items, replaceData){
            const itemsReplaced = [];
            for (const item of items) {
                const verifyItem = Object.assign({}, item);
                const keys = Object.keys(verifyItem);
                for (const key of keys) {
                    if(key === "date") continue;
                    if(verifyItem[key] !== 0 && !verifyItem[key]){
                        verifyItem[key] = replaceData;
                    }
                }
                itemsReplaced.push(verifyItem);
            }
            return itemsReplaced;
        },

        removeDatesWithEmptyValues(items){
            const itemsReplaced = [];
            for (const item of items) {
                const verifyItem = Object.assign({}, item);
                const verifyItemAsArray = Object.entries(verifyItem);
                const emptyDates = verifyItemAsArray.filter((entryItem) => {
                    const [ key, value ] = entryItem;
                    return key !== "date" && (value || value === 0)
                });
                if(emptyDates.length){
                    itemsReplaced.push(verifyItem);
                }
            }
            return itemsReplaced;
        },

        formatDate(date){
            const stringFormat = "DD/MM/YYYY HH:mm";
            return moment(date).tz("America/Sao_Paulo").locale("pt-br").format(stringFormat);
        },

        capitalize(text){
            return text[0].toUpperCase() + text.slice(1);
        },

        generateExportFileName(searchResult){
            const typeName = "dados_observados";
            const stationName = searchResult.station.nome;
            const periodFormat = `${this.formatDate(searchResult.date_start)} até ${this.formatDate(searchResult.date_end)}`
            return `${stationName}-${typeName}-${periodFormat}`;
        }
    }
}
</script>

<style scoped>
    
</style>